// components/forms/ForgotPasswordForm.jsx
import React, { useState } from "react";
import { toast } from "react-toastify";
import { sendResetPasswordEmail } from "../../hooks/api";

export default function ForgotPasswordForm({ onBackToLogin }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false); // ✅ new loading state

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return; // prevent double click

    try {
      setLoading(true); // ✅ start loading

      const res = await sendResetPasswordEmail(email);

      if (res.success) {
        toast.success("Reset link sent to your email.");
      } else {
        toast.error(res.error || "Failed to send reset link.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // ✅ stop loading
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h5 className="mb-3">🔐 Forgot Password</h5>

      <input
        className="form-control mb-3"
        type="email"
        placeholder="Enter your email"
        value={email}
        required
        onChange={(e) => setEmail(e.target.value)}
        disabled={loading} // optional
      />

      <button
        className="btn btn-primary w-100"
        disabled={loading}
      >
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Sending...
          </>
        ) : (
          "Send Reset Link"
        )}
      </button>

      <div className="text-center mt-2">
        <button
          type="button"
          className="btn btn-link"
          onClick={onBackToLogin}
          disabled={loading}
        >
          Back to Login
        </button>
      </div>
    </form>
  );
}
